import {DateFormatEnum} from 'presentation/constants';
import {formatDateString, isTeleconsultationAvailable} from 'presentation/utils';
import {useEffect, useMemo, useState} from 'react';

const ONE_MINUTE_IN_MILLISECONDS = 1000 * 60;

export const useMonitoringTime = (dateAppointment: string) => {
	const {showEnterRoom, date} = isTeleconsultationAvailable(dateAppointment);
	const [goToTelehealthAvailabilityState, setGoToTelehealthAvailabilityState] =
		useState(showEnterRoom);
	const [dateStringState, setDateStringState] = useState(date);

	const hourStringFormatted = useMemo(
		() => formatDateString(dateStringState, DateFormatEnum.DATE_FORMAT_9, 'HH:mm'),
		[dateStringState],
	);

	useEffect(() => {
		const interval = setInterval(() => {
			const {showEnterRoom: newShowEnterRoom, date: newDate} =
				isTeleconsultationAvailable(dateAppointment);
			setGoToTelehealthAvailabilityState(newShowEnterRoom);
			setDateStringState(newDate);
		}, ONE_MINUTE_IN_MILLISECONDS);

		return () => clearInterval(interval);
	}, [dateStringState]);

	return {
		goToTelehealthAvailability: goToTelehealthAvailabilityState,
		dateString: dateStringState,
		hourStringFormatted,
	};
};
